<div class="bottom-navigation-bar">
  <button
    #homeBtn
    class="bottom-navigation-btn"
    mat-ripple
    routerLinkActive="active"
    routerLink="/"
    [routerLinkActiveOptions]="{ exact: true }"
  >
    <mat-icon [fontSet]="homeBtn.classList.contains('active') ? 'mat-symbol-round-fill' : 'mat-symbol-round'">
      home
    </mat-icon>
    <span>خانه</span>
  </button>
  <button
    class="bottom-navigation-btn"
    mat-ripple
    #searchBtn
    routerLinkActive="active"
    routerLink="/search"
    [routerLinkActiveOptions]="{ exact: true }"
  >
    <mat-icon [fontSet]="searchBtn.classList.contains('active') ? 'mat-symbol-round-fill' : 'mat-symbol-round'">
      search
    </mat-icon>
    <span>جستجو</span>
  </button>
  @if (tokenService.userInfo()) {
    <button
      class="bottom-navigation-btn"
      mat-ripple
      #profileBtn
      routerLinkActive="active"
      routerLink="/profile"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <app-image-generator
        [sizes]="profileSizes"
        class="avatar-image"
        imageType="square"
        [src]="tokenService.userInfo()!.activeProfile.avatar"
        [name]="tokenService.userInfo()!.activeProfile.name"
      />
      <span>پروفایل</span>
    </button>
  } @else {
    <button
      class="bottom-navigation-btn"
      mat-ripple
      #loginBtn
      routerLinkActive="active"
      routerLink="/auth"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <mat-icon [fontSet]="loginBtn.classList.contains('active') ? 'mat-symbol-round-fill' : 'mat-symbol-round'">
        person
      </mat-icon>
      <span>ورود</span>
    </button>
  }
</div>
